import { Component, Input } from '@angular/core';
import { TrackToolStep } from '@analytics/models';
import type {
  ScAddressFormInput,
  ScCheckboxFormInput,
  ScCheckboxSetFormInput,
  ScDropDownFormInput,
  ScEmailFormInput,
  ScFormFormGroupState,
  ScFormInput,
  ScNameFormInput,
  ScPaymentFormInput,
  ScPhoneFormInput,
  ScRadioFormInput,
  ScTextFormInput,
  ScWidgetInput,
} from '@innogy/sitecore-forms/models';
import { ScForm } from '@innogy/sitecore-forms/models';
import { controlNameForInput } from '@innogy/sitecore-forms/store';
import { FormGroupState } from 'ngrx-forms';
import { NgTemplateOutlet } from '@angular/common';
import { InputErrorComponent } from '@innogy/common-ui/forms';
import { CastPipe } from '@innogy/utils-deprecated';

import { ScAddressComponent } from '../inputs/sc-address/sc-address.component';
import { ScTextComponent } from '../inputs/sc-text/sc-text.component';
import { ScCheckboxComponent } from '../inputs/sc-checkbox/sc-checkbox.component';
import { ScCheckboxSetComponent } from '../inputs/sc-checkbox-set/sc-checkbox-set.component';
import { ScEmailComponent } from '../inputs/sc-email/sc-email.component';
import { ScNameComponent } from '../inputs/sc-name/sc-name.component';
import { ScPaymentComponent } from '../inputs/sc-payment/sc-payment.component';
import { ScDropdownComponent } from '../inputs/sc-dropdown/sc-dropdown.component';
import { ScPhoneComponent } from '../inputs/sc-phone/sc-phone.component';
import { ScRadioComponent } from '../inputs/sc-radio/sc-radio.component';

@Component({
  selector: 'wl-generic-form[form][formState][trackStep]',
  templateUrl: './generic-form.component.html',
  standalone: true,
  imports: [
    ScAddressComponent,
    ScTextComponent,
    NgTemplateOutlet,
    ScCheckboxComponent,
    ScCheckboxSetComponent,
    ScEmailComponent,
    ScNameComponent,
    ScPaymentComponent,
    ScDropdownComponent,
    ScPhoneComponent,
    ScRadioComponent,
    InputErrorComponent,
    CastPipe,
  ],
})
export class GenericFormComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() form!: ScForm;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() formState!: FormGroupState<ScFormFormGroupState>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() trackStep!: TrackToolStep;

  toTextFormInputFields!: ScTextFormInput;
  toCheckboxFormInputFields!: ScCheckboxFormInput;
  toCheckboxSetFormInputFields!: ScCheckboxSetFormInput;
  toEmailFormInputFields!: ScEmailFormInput;
  toNameFormInputFields!: ScNameFormInput;
  toPaymentFormInputFields!: ScPaymentFormInput;
  toAddressInputFields!: ScAddressFormInput;
  toDropdownFormInputFields!: ScDropDownFormInput;
  toPhoneFormInputFields!: ScPhoneFormInput;
  toRadioFormInputFields!: ScRadioFormInput;
  toWidgetInputFields!: ScWidgetInput;

  controlForInput(input: ScFormInput) {
    return this.formState.controls[controlNameForInput(input)];
  }
}
